import { onScopeDispose, ref, watch } from "vue";

export const useAutoFinalize = (
  isReady: () => boolean,
  finalize: () => void | Promise<void>,
) => {
  const active = ref(false);
  const countdown = ref(0);
  let dismissed = false;
  let timer: ReturnType<typeof setInterval> | undefined;

  const stop = () => {
    clearInterval(timer);
    timer = undefined;
    active.value = false;
    countdown.value = 0;
  };

  // A manual submission or cancellation must not restart on a data refresh.
  const cancel = () => {
    dismissed = true;
    stop();
  };

  watch(
    isReady,
    (ready) => {
      stop();
      if (!ready || dismissed) return;
      active.value = true;
      countdown.value = 5;
      timer = setInterval(() => {
        if (!isReady()) {
          stop();
          return;
        }
        countdown.value--;
        if (countdown.value === 0) {
          cancel();
          void finalize();
        }
      }, 1000);
    },
    { immediate: true },
  );

  onScopeDispose(stop);
  return { active, countdown, cancel };
};
